import React, {ChangeEventHandler} from 'react';
import {FacetItem} from '../../../types/Search';

type FilterItemProps = {
  itemKey: string;
  item: FacetItem;
  onSelectEventHandler: ChangeEventHandler;
  customLabel?: string;
}

/**
 * Component which renders a single filtering item as a <LI>, containing label and document count
 * @param props component properties
 */
export function FilterItem(props: FilterItemProps) {
  const {item, itemKey, onSelectEventHandler, customLabel} = props;
  return (
    <li className="filter">
      <input type="checkbox" id={itemKey}
             name={itemKey}
             onChange={onSelectEventHandler}
             checked={item.selected}/>
      <label className="label text-truncate" title={item.key} htmlFor={itemKey}>
        {customLabel ? customLabel : item.key}
      </label>
      <span className="count">({item.count})</span>
    </li>
  )
}
